/**
 * Promise wrapper around XMLHttpRequest
 *
 * @param {Object} options
 * @param {string} options.method HTTP method (GET, POST, etc.)
 * @param {string} options.url base url to send to
 * @param {string|Object} options.params parameter data
 * @param {Object} options.headers headers
 * @return {Promise} resolves to response or rejects with error
 */
export function makeRequest(options) {
    return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open(options.method, options.url);
        xhr.onload = function onLoad() {
            if (this.status >= 200 && this.status < 300) {
                resolve(xhr.response);
            } else {
                reject({
                    status: this.status,
                    statusText: xhr.statusText
                });
            }
        };
        xhr.onerror = function onError() {
            reject({
                status: this.status,
                statusText: xhr.statusText
            });
        };
        if (options.headers) {
            Object.keys(options.headers).forEach((key) => {
                xhr.setRequestHeader(key, options.headers[key]);
            });
        }
        let { params } = options;
        // stringify if we've been given an object
        if (params && typeof params === "object") {
            params = Object.keys(params)
                .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
                .join("&")
                .replace(/%20/g, "+");
        }
        xhr.send();
    });
}

/**
 * Tries to use crappy liferay endpoint. This endpoint doesn't support CORS and occasionally breaks ¯\_(ツ)_/¯
 * @returns {Promise} getData object containing country and state
 */
export function getLocationFromIP(dataToMerge = {}) {
    return makeRequest({
        method: "POST",
        url:
            "https://www.rosettastone.com/product-activation/?p_p_id=responsysservicesportlet_WAR_responsysservicesportlet&p_p_lifecycle=2"
    })
        .then((ipResponse) => {
            if (!(ipResponse && ipResponse.match(/\((.*)\)/))) {
                // TODO Log errors console.error("Something went wrong getting the IP", ipResponse);
                return null;
            }
            const dataJson = ipResponse.match(/\((.*)\)/)[1];
            // const stgOrNot = /\.stg\./i.test(window.location.href) ? "stg." : "";
            const ip = JSON.parse(dataJson).ipaddress.split(",")[0];
            const url = `https://www.rosettastone.com/institutional/web/us-institution/?p_p_id=rosettaservices_WAR_institutionalrosettaservicesportlet&p_p_lifecycle=2&p_p_resource_id=GeoIP_request&redirect2mobile=disabled&ipaddr=${ip}`;
            return makeRequest({
                method: "GET",
                url
            });
        })
        .then((geoResponse) => {
            if (!geoResponse) {
                // TODO Log errors console.error("Something went wrong getting the location", geoResponse);
                return null;
            }
            const geoDataArray = geoResponse.split("|");
            return {
                country: geoDataArray[0],
                state: geoDataArray[1],
                city: geoDataArray[2],
                zip: geoDataArray[3],
                ...dataToMerge
            };
        })
        .catch(() => {
            // TODO Log errors console.error(err);
        });
}
